(() => {
  if (window.__sihaHomeMotionLoaded) return;
  window.__sihaHomeMotionLoaded = true;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initHero = (hero) => {
    if (!hero || hero.dataset.sihaReady === 'true') return;
    hero.dataset.sihaReady = 'true';
    const slides = [...hero.querySelectorAll('[data-siha-slide]')];
    if (slides.length < 2) return;
    let index = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));
    const dotsWrap = hero.querySelector('[data-siha-hero-dots]');
    const interval = Math.max(4000, Number(hero.dataset.interval || 5000));
    const autoplay = hero.dataset.autoplay === 'true' && !reduced;
    let timer = null;
    let startX = 0;

    const dots = slides.map((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'siha-dynamic-hero__dot' + (i === index ? ' is-active' : '');
      b.setAttribute('aria-label', `Vai all'immagine ${i + 1}`);
      b.addEventListener('click', () => show(i, true));
      dotsWrap?.appendChild(b);
      return b;
    });

    const show = (next, manual = false) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      if (manual) restart();
    };
    const restart = () => {
      if (timer) clearInterval(timer);
      if (autoplay) timer = setInterval(() => show(index + 1), interval);
    };

    hero.querySelector('[data-siha-hero-prev]')?.addEventListener('click', () => show(index - 1, true));
    hero.querySelector('[data-siha-hero-next]')?.addEventListener('click', () => show(index + 1, true));
    hero.addEventListener('mouseenter', () => timer && clearInterval(timer));
    hero.addEventListener('mouseleave', restart);
    hero.addEventListener('focusin', () => timer && clearInterval(timer));
    hero.addEventListener('focusout', restart);
    hero.addEventListener('touchstart', (e) => { startX = e.touches[0]?.clientX || 0; }, {passive:true});
    hero.addEventListener('touchend', (e) => {
      const endX = e.changedTouches[0]?.clientX || startX;
      if (Math.abs(endX - startX) > 45) show(index + (endX < startX ? 1 : -1), true);
    }, {passive:true});
    restart();
  };

  const initMotion = () => {
    const main = document.querySelector('.content-for-layout[data-template="index"]');
    if (!main) return;
    document.documentElement.classList.add('siha-motion-ready');

    const revealSelectors = [
      '.siha-promo-banner__eyebrow', '.siha-promo-banner__content h2', '.siha-promo-banner__content .rte', '.siha-promo-banner__actions',
      '.siha-brand-showcase__header > *', '.siha-japan__content > *',
      '.product-list .static-header, product-card.product-card', '.siha-faq__header > *'
    ];
    const items = [...main.querySelectorAll(revealSelectors.join(','))];
    items.forEach((el) => {
      el.classList.add('siha-motion-item');
      const parent = el.closest('.product-list, .product-grid, .siha-brand-showcase, .siha-promo-banner');
      if (parent && el.matches('product-card.product-card')) {
        const siblings = [...parent.querySelectorAll('product-card.product-card')];
        const pos = siblings.indexOf(el);
        el.style.setProperty('--siha-motion-delay', `${Math.min(pos, 5) * 70}ms`);
      }
    });

    const revealMedia = [...main.querySelectorAll('.siha-promo-banner__media, .siha-japan__media')];
    revealMedia.forEach((el) => el.classList.add('siha-image-reveal'));

    if (reduced) {
      [...items, ...revealMedia].forEach((el) => el.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {threshold: .12, rootMargin: '0px 0px -4% 0px'});
      [...items, ...revealMedia].forEach((el) => observer.observe(el));
    }

    if (!reduced) {
      const parallaxMedia = [...main.querySelectorAll('.siha-promo-banner__media')];
      parallaxMedia.forEach((el) => el.setAttribute('data-siha-parallax', ''));
      let ticking = false;
      const updateParallax = () => {
        ticking = false;
        const vh = window.innerHeight || 800;
        parallaxMedia.forEach((el) => {
          const r = el.getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) return;
          const progress = ((r.top + r.height / 2) - vh / 2) / vh;
          const y = Math.max(-10, Math.min(10, progress * -14));
          el.style.setProperty('--siha-parallax-y', `${y.toFixed(1)}px`);
        });
      };
      window.addEventListener('scroll', () => {
        if (!ticking) { ticking = true; requestAnimationFrame(updateParallax); }
      }, {passive:true});
      updateParallax();
    }

    main.querySelectorAll('.siha-brand-showcase__scroller').forEach((scroller) => {
      const grid = scroller.querySelector('.siha-brand-showcase__grid');
      if (!grid || grid.dataset.sihaMarquee === 'true') return;
      grid.dataset.sihaMarquee = 'true';
      const originals = [...grid.children];
      if (originals.length < 2) return;
      originals.forEach((node) => {
        const clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach((el) => el.setAttribute('tabindex', '-1'));
        grid.appendChild(clone);
      });
      scroller.classList.add('siha-marquee-active');
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-siha-dynamic-hero]').forEach(initHero);
    initMotion();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* SIHA OUTLET — TREND & OPPORTUNITY POSITIONING V3 */
(() => {
  if (window.__sihaSizeDiscoveryV3) return;
  window.__sihaSizeDiscoveryV3 = true;

  const sizeLinks = ['35','36','37','38','39','40','41','42','43','44','45','46'];

  const setSlideCopy = (slide, eyebrowCopy, headingCopy, textCopy, ctaCopy, ctaHref) => {
    if (!slide) return;
    const eyebrow = slide.querySelector('.siha-dynamic-hero__eyebrow');
    const heading = slide.querySelector('.siha-dynamic-hero__heading');
    const text = slide.querySelector('.siha-dynamic-hero__text');
    const cta = slide.querySelector('.siha-dynamic-hero__cta');
    if (eyebrow && eyebrowCopy) eyebrow.textContent = eyebrowCopy;
    if (heading && headingCopy) heading.textContent = headingCopy;
    if (text && textCopy) text.innerHTML = `<p>${textCopy}</p>`;
    if (cta && ctaCopy) {
      if (ctaHref) cta.href = ctaHref;
      const label = cta.querySelector('span');
      if (label) label.textContent = ctaCopy;
      else cta.textContent = ctaCopy;
    }
  };

  const updateHero = (hero) => {
    const slides = [...(hero?.querySelectorAll('[data-siha-slide]') || [])];
    setSlideCopy(
      slides[0],
      'MODA ATTUALE. OCCASIONI VERE.',
      'La tendenza che cerchi, al prezzo outlet.',
      'Articoli di tendenza, selezionati in pochi pezzi e taglie.',
      'SCOPRI I NUOVI ARRIVI',
      '/collections/nuovi-arrivi'
    );
    setSlideCopy(
      slides[2],
      'OCCASIONI CHE CAMBIANO',
      'Segui la moda. Spendi meglio.',
      'Scopri le occasioni alla moda disponibili adesso.',
      'SCOPRI LE OCCASIONI',
      '/collections/nuovi-arrivi'
    );
  };

  const updateCategoryLinks = (hero) => {
    if (!hero) return;
    const routes = {
      'donna': '/collections/moda-donna',
      'uomo': '/collections/moda-uomo',
      'bambini': '/collections/moda-bambini',
      'borse a mano': '/collections/borse-donna',
      'saldi': '/collections/outlet'
    };
    hero.querySelectorAll('.siha-category-strip a').forEach((link) => {
      const key = (link.textContent || '').trim().toLowerCase();
      if (routes[key]) link.href = routes[key];
    });
  };

  const updateExistingHomeCopy = (main) => {
    const headingMap = new Map([
      ['fuori tutto, sconti fino al 70%', 'Occasioni alla moda disponibili ora'],
      ['scegli il tuo stile', 'Tendenze Japan Style'],
      ['da scoprire per uomo', 'Tendenze Uomo'],
      ['da scoprire per bambini', 'Tendenze Bambini']
    ]);

    main.querySelectorAll('h1,h2,h3,h4,.static-header').forEach((el) => {
      const key = (el.textContent || '').trim().toLowerCase().replace(/\s+/g, ' ');
      if (!headingMap.has(key)) return;
      el.textContent = headingMap.get(key);
      if (key === 'fuori tutto, sconti fino al 70%') el.style.color = '#111111';
    });

    main.querySelectorAll('a,button').forEach((el) => {
      const key = (el.textContent || '').trim().toLowerCase().replace(/\s+/g, ' ');
      if (key === 'trova il tuo stile') el.textContent = 'SCOPRI LE OCCASIONI';
      if (key === 'scopri la collezione') el.textContent = 'SCOPRI LE OCCASIONI';
      if (key === 'vedi tutta la collezione') el.textContent = 'Vedi tutte le occasioni';
    });
  };

  const buildDiscovery = () => {
    const section = document.createElement('section');
    section.id = 'siha-size-discovery-v1';
    section.className = 'siha-size-discovery';
    section.setAttribute('aria-labelledby', 'siha-size-title');

    const sizes = sizeLinks.map((size) => `
      <a class="siha-size-discovery__size" href="/collections/taglia-${size}" aria-label="Scopri le occasioni disponibili nella taglia ${size}">${size}</a>
    `).join('');

    section.innerHTML = `
      <div class="siha-size-discovery__inner">
        <div class="siha-size-discovery__intro">
          <p class="siha-size-discovery__eyebrow">SHOP BY SIZE</p>
          <h2 id="siha-size-title">Trova la tua taglia</h2>
          <p class="siha-size-discovery__lead">Scopri subito le occasioni disponibili nella tua misura.</p>
        </div>
        <div class="siha-size-discovery__sizes" aria-label="Scegli la tua taglia">
          ${sizes}
        </div>
        <div class="siha-size-discovery__trust" aria-label="Perché scegliere SIHA OUTLET" data-siha-trust-track>
          <div class="siha-size-discovery__trust-item is-active" data-siha-trust-item><strong>Disponibilità aggiornata</strong><span>Vedi le taglie acquistabili adesso.</span></div>
          <div class="siha-size-discovery__trust-item" data-siha-trust-item><strong>Tendenze in pochi pezzi</strong><span>Occasioni alla moda, spesso disponibili in poche unità.</span></div>
          <div class="siha-size-discovery__trust-item" data-siha-trust-item><strong>Nuovi arrivi ogni settimana</strong><span>Nuove occasioni da scoprire.</span></div>
          <div class="siha-size-discovery__trust-item" data-siha-trust-item><strong>Foto fedeli al prodotto</strong><span>Ogni articolo è mostrato nel modo più realistico possibile.</span></div>
        </div>
        <div class="siha-size-discovery__trust-dots" aria-label="Navigazione vantaggi">
          <button class="siha-size-discovery__trust-dot is-active" type="button" data-siha-trust-dot="0" aria-label="Mostra vantaggio 1" aria-pressed="true"></button>
          <button class="siha-size-discovery__trust-dot" type="button" data-siha-trust-dot="1" aria-label="Mostra vantaggio 2" aria-pressed="false"></button>
          <button class="siha-size-discovery__trust-dot" type="button" data-siha-trust-dot="2" aria-label="Mostra vantaggio 3" aria-pressed="false"></button>
          <button class="siha-size-discovery__trust-dot" type="button" data-siha-trust-dot="3" aria-label="Mostra vantaggio 4" aria-pressed="false"></button>
        </div>
        <div class="siha-size-discovery__story">
          <div>
            <p class="siha-size-discovery__story-eyebrow">IL NOSTRO OUTLET</p>
            <h3>Moda attuale, occasioni che cambiano.</h3>
          </div>
          <div class="siha-size-discovery__story-copy">
            <p>Seguiamo le tendenze e selezioniamo occasioni disponibili in pochi pezzi e taglie. Le foto sono realizzate per rappresentare ogni articolo nel modo più fedele possibile, così sai meglio cosa aspettarti.</p>
            <a class="siha-size-discovery__story-cta" href="/collections/nuovi-arrivi">SCOPRI I NUOVI ARRIVI <span aria-hidden="true">→</span></a>
          </div>
        </div>
      </div>
    `;
    return section;
  };

  const initSizeDiscoveryTrustCarousel = (section) => {
    if (!section) return;

    const track = section.querySelector('[data-siha-trust-track]');
    const items = [...section.querySelectorAll('[data-siha-trust-item]')];
    const dots = [...section.querySelectorAll('[data-siha-trust-dot]')];

    if (!track || items.length < 2 || track.dataset.sihaCarouselReady === 'true') return;

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const autoplayDelay = 3500;
    const resumeDelay = 4500;

    let currentIndex = 0;
    let timer = null;
    let resumeTimer = null;
    let scrollFrame = null;
    let pointerDown = false;

    const setActive = (index) => {
      currentIndex = Math.max(0, Math.min(index, items.length - 1));

      items.forEach((item, itemIndex) => {
        item.classList.toggle('is-active', itemIndex === currentIndex);
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-pressed', String(isActive));
      });
    };

    const stopAutoplay = () => {
      window.clearTimeout(timer);
      timer = null;
    };

    const canAutoplay = () => (
      mobileQuery.matches &&
      !reduceMotionQuery.matches &&
      document.visibilityState === 'visible' &&
      !pointerDown
    );

    const goTo = (index, smooth = true) => {
      if (!mobileQuery.matches) return;

      const normalizedIndex = (index + items.length) % items.length;
      const target = items[normalizedIndex];

      setActive(normalizedIndex);
      track.scrollTo({
        left: target.offsetLeft,
        behavior: smooth && !reduceMotionQuery.matches ? 'smooth' : 'auto',
      });
    };

    const startAutoplay = (delay = autoplayDelay) => {
      stopAutoplay();
      if (!canAutoplay()) return;

      timer = window.setTimeout(() => {
        goTo(currentIndex + 1, true);
        startAutoplay();
      }, delay);
    };

    const restartAutoplay = (delay = resumeDelay) => {
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(() => startAutoplay(), delay);
    };

    const handleScroll = () => {
      if (!mobileQuery.matches || scrollFrame) return;

      scrollFrame = window.requestAnimationFrame(() => {
        const trackCenter = track.scrollLeft + track.clientWidth / 2;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        items.forEach((item, index) => {
          const itemCenter = item.offsetLeft + item.offsetWidth / 2;
          const distance = Math.abs(trackCenter - itemCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        setActive(closestIndex);
        scrollFrame = null;
      });
    };

    track.addEventListener('scroll', handleScroll, { passive: true });
    track.addEventListener('pointerdown', () => {
      pointerDown = true;
      stopAutoplay();
      window.clearTimeout(resumeTimer);
    }, { passive: true });
    track.addEventListener('pointerup', () => {
      pointerDown = false;
      restartAutoplay();
    }, { passive: true });
    track.addEventListener('pointercancel', () => {
      pointerDown = false;
      restartAutoplay();
    }, { passive: true });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number.parseInt(dot.dataset.sihaTrustDot, 10);
        goTo(index, true);
        restartAutoplay();
      });
    });

    const handleMediaChange = () => {
      stopAutoplay();
      window.clearTimeout(resumeTimer);

      if (mobileQuery.matches) {
        window.requestAnimationFrame(() => goTo(currentIndex, false));
        startAutoplay();
      } else {
        track.scrollTo({ left: 0, behavior: 'auto' });
        setActive(0);
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') startAutoplay();
      else stopAutoplay();
    };

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', handleMediaChange);
      reduceMotionQuery.addEventListener('change', handleMediaChange);
    } else {
      mobileQuery.addListener(handleMediaChange);
      reduceMotionQuery.addListener(handleMediaChange);
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);

    track.dataset.sihaCarouselReady = 'true';
    setActive(0);
    handleMediaChange();
  };

  const initSihaSizeDiscovery = () => {
    const main = document.querySelector('.content-for-layout[data-template="index"]');
    if (!main) return;
    const hero = main.querySelector('[data-siha-dynamic-hero]');
    if (!hero) return;

    updateHero(hero);
    updateCategoryLinks(hero);
    updateExistingHomeCopy(main);

    const existingDiscovery = document.getElementById('siha-size-discovery-v1');
    if (!existingDiscovery) {
      const heroSection = hero.closest('.shopify-section');
      const discovery = buildDiscovery();
      if (heroSection?.parentNode) heroSection.insertAdjacentElement('afterend', discovery);
      else hero.insertAdjacentElement('afterend', discovery);
      initSizeDiscoveryTrustCarousel(discovery);
    } else {
      initSizeDiscoveryTrustCarousel(existingDiscovery);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSihaSizeDiscovery, { once: true });
  } else {
    initSihaSizeDiscovery();
  }
  document.addEventListener('shopify:section:load', initSihaSizeDiscovery);
})();
